export default "__VITE_ASSET__Bdm54Gvk__"